import React from 'react';
import { Control } from 'react-hook-form';
import { Question, Section } from './data';
import DynamicQuestion from './DynamicQuestion';
import DynamicFormSection from './DynamicFormSection';

interface DynamicFormItemProps {
  question: Question | Section;
  control: Control;
}

export default function DynamicFormItem({ question, control }: DynamicFormItemProps) {
  if (question.type === 'section') {
    return <DynamicFormSection section={question as Section} control={control} />;
  }

  return <DynamicQuestion question={question} control={control} />;
}
